var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 32 32",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.29883,15.25C28.15088,9.7998,22.28906,6.41406,16,6.41406S3.84912,9.7998,0.70117,15.25c-0.26807,0.46387-0.26807,1.03613,0,1.5C3.84912,22.2002,9.71094,25.58594,16,25.58594S28.15088,22.2002,31.29883,16.75C31.56689,16.28613,31.56689,15.71387,31.29883,15.25z M16,22.58594c-4.92578,0-9.53662-2.50244-12.23682-6.58594C6.46338,11.9165,11.07422,9.41406,16,9.41406S25.53662,11.9165,28.23682,16C25.53662,20.0835,20.92578,22.58594,16,22.58594z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10.44629c-3.0625,0-5.55371,2.49121-5.55371,5.55371S12.9375,21.55371,16,21.55371S21.55371,19.0625,21.55371,16S19.0625,10.44629,16,10.44629z M16,18.55371c-1.4082,0-2.55371-1.14551-2.55371-2.55371S14.5918,13.44629,16,13.44629S18.55371,14.5918,18.55371,16S17.4082,18.55371,16,18.55371z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.26b1f5d27ea863271ff382baa7141266.svg";
export { ForwardRef as ReactComponent };